import { hasParentNodeOfType } from '@atlaskit/editor-prosemirror/utils';
export var insideTable = function insideTable(state) {
  var _state$schema$nodes = state.schema.nodes,
    table = _state$schema$nodes.table,
    tableCell = _state$schema$nodes.tableCell;
  return hasParentNodeOfType([table, tableCell])(state.selection);
};